module.exports = __webpack_public_path__ + "img/vote-time-title@2x.3174d9b7.png";